<template>
    <div class="phone">
        <div v-if="!use || status['dialpad'] || status['forward']">
            <div v-if="!use" class="stage">
                <Tabs :meta="{
                    type: 'category',
                    extras: `R0:key=dial,value=شماره گیری;
                        R1:key=history,value=تاریخچه;
                        R2:key=contacts,value=مخاطبین`
                }" :vm="models['stage']" @onchange="(obj) => models['stage'] = obj.value"></Tabs>
            </div>
            <Dial v-show="stage === 'dial' || status['dialpad'] || status['forward']" :data="data()"
                @onchange="(obj) => models['destination'] = obj.value" @call="call" @cancel="() => {
                    status['forward'] = false
                    status['dialpad'] = false
                }" @dialpad="dialpad" @forward="forward"></Dial>
            <History v-if="!use" v-show="stage === 'history'" :data="data()" @dial="(obj) => {
                models['stage'] = 'dial'
                models['destination'] = obj
            }"></History>
            <Contacts v-if="!use" v-show="stage === 'contacts'" :data="data()"></Contacts>
        </div>
        <Calling v-else :data="data()" @dialpad="(duration) => {
            status['forward'] = false
            status['dialpad'] = true

            models['duration'] = duration
        }" @mute="mute" @hold="hold" @keypad="(duration) => {
            status['dialpad'] = false
            status['forward'] = true

            models['duration'] = duration
        }" @answer="answer" @reject="reject" @hangup="hangup" @cleanup="cleanup"></Calling>
    </div>
    <audio ref="context" autoplay muted></audio>
    <audio ref="peer" autoplay></audio>
</template>

<script>
/* eslint-disable */
import { markRaw } from 'vue'
import JsSIP from 'jssip'
import Dial from './Dial.vue'
import History from './History.vue'
import Contacts from './Contacts.vue'
import Calling from './Calling.vue'
import Tabs from '../Form/Inputs/Tabs.vue'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'SIP',
    props: ['theme', 'user'],
    inject: ['base', 'entities'],
    components: { Dial, History, Contacts, Calling, Tabs },
    computed: {
        use() {
            return (this.status['description'] === 'established'
                || this.status['description'] === 'incoming'
                || this.status['description'] === 'dialing'
                || this.status['results'])
        },
        stage() {
            return this.models['stage']
        }
    },
    created() {
        this.init()
    },
    data() {
        return {
            ua: null,
            session: null,
            direction: null,
            media: {
                audio: true,
                video: false
            },
            streams: {
                audio: null,
                video: null
            },
            tones: {
                ringtone: new Audio('/sounds/ringtone.mp3'),
                dtmfTone: new Audio('/sounds/dtmf.mp3'),
                busyTone: new Audio('/sounds/busy.mp3'),
                waitingTone: new Audio('/sounds/waiting.mp3')
            },
            models: {
                stage: 'dial',
                destination: ''
            },
            endpoint: {
                ws: '',
                domain: '',
                uri: '',
                username: '',
                password: ''
            },
            status: {
                registration: false,
                mute: false,
                hold: false,
                dialpad: false,
                forward: false,
                results: false,
                description: 'offline'
            },
            extras: {},
            information: {
                unique_id: '',
                called_at: 0
            }
        }
    },
    methods: {
        init() {
            this.base.API().post(`Security/Credential/Find`, {
                data: {
                    scope: '{My:0}',
                    type: 'phone'
                }
            }, (response) => {
                if (this.base.Util().success(response)
                    && response.data.data) {
                    const credential = response.data.data[0]
                    if (credential.status !== 104) {
                        const extras = this.base.Entities().parse(credential.extras)
                        this.endpoint = {
                            ws: `wss://${extras['endpoint']}:${extras['port']}/ws`,
                            domain: extras['endpoint'],
                            uri: `sip:${credential.username}@${extras['endpoint']}`,
                            username: credential.username,
                            password: credential.password
                        }

                        Object.keys(this.tones).forEach((key) => this.tones[key].loop = true)
                        if (!this.ua) {
                            this.ua = markRaw(new JsSIP.UA({
                                sockets: [new JsSIP.WebSocketInterface(this.endpoint['ws'])],
                                uri: this.endpoint['uri'],
                                password: this.endpoint['password'],
                                display_name: 'Jahan Ju SIP Client',
                                realm: 'asterisk',
                                pcConfig: {
                                    iceServers: []
                                }
                            }))
                            this.ua.on('registered', () => {
                                this.status['registration'] = true
                                this.status['description'] = 'onhook'
                            })
                            this.ua.on('unregistered', () => {
                                this.status['registration'] = false
                                this.status['description'] = 'offline'
                            })

                            this.ua.on('newRTCSession', (data) => {
                                Object.keys(this.tones).forEach((key) => this.tones[key].currentTime = 0)
                                if (this.session || this.status['results'])
                                    if (data.session.direction === 'incoming') {
                                        try {
                                            data.session.terminate({
                                                status_code: 486,
                                                reason_phrase: 'Busy Here'
                                            })
                                        } catch (e) {
                                        }
                                        return
                                    }
                                this.session = data.session

                                const xuid = this.session?._request?.headers['X-Unique-Id']
                                if (xuid)
                                    this.information['unique_id'] = xuid[0]?.raw
                                else {
                                    const euid = this.session?._request?.extraHeaders[0]
                                    if (euid)
                                        this.information['unique_id'] = String(euid)?.split(': ')[1]
                                }

                                let _user = this.session.direction === 'incoming'
                                    ? String(this.session.remote_identity.uri).split(':')[1].split('@')[0]
                                    : this.models['destination']
                                if (!String(_user).startsWith('98'))
                                    _user = `98${String(_user).slice(String(_user).startsWith('0') ? 1 : 0
                                        , _user.length)}`
                                else if (String(_user).startsWith('980'))
                                    _user = `98${String(_user).slice(3, _user.length)}`

                                if (_user && String(_user).startsWith('98')) {
                                    this.base.API().get(`Stream/CDR/GetContact?caller=${_user}`, (response) => {
                                        if (this.base.Util().success(response)
                                            && this.base.Util().validate(response.data.data)) {
                                            this.extras = response.data.data
                                            if (!this.extras['uid'])
                                                this.extras['context'] = 'newsletter'
                                        }
                                    }, (error) => {
                                    })
                                }

                                this.information['called_at'] = Date.now()
                                switch (this.session.direction) {
                                    case 'incoming':
                                        this.$emit('onevent', 'incoming')

                                        this.status['description'] = 'incoming'

                                        this.tones.ringtone.play()

                                        this.session.on('accepted', () => {
                                            this.$emit('onevent', 'accepted')

                                            this.direction = 'incoming'
                                            this.status['description'] = 'established'
                                            this.tones.ringtone.pause()
                                        })
                                        break
                                    case 'outgoing':
                                        this.tones.dtmfTone.play()

                                        this.session.on('accepted', () => {
                                            this.$emit('onevent', 'accepted')

                                            this.direction = 'outgoing'
                                            this.status['description'] = 'established'
                                            this.tones.dtmfTone.pause()

                                            if (this.session.connection) {
                                                this.session.connection.ontrack = (event) => {
                                                    if (event.streams && event.streams[0]) {
                                                        if (this.$refs.peer)
                                                            this.$refs.peer.srcObject = event.streams[0]
                                                        else
                                                            console.error('Remote audio ref not available')
                                                    } else
                                                        console.error('No remote streams in ontrack event')
                                                }

                                                setTimeout(() => {
                                                    if (this.$refs.peer && !this.$refs.peer.srcObject
                                                        && this.session.connection.getReceivers)
                                                        this.session.connection.getReceivers().forEach((receiver) => {
                                                            if (receiver.track && receiver.track.kind === 'audio')
                                                                this.$refs.peer.srcObject = new MediaStream([receiver.track])
                                                        })
                                                }, 1000)
                                            }
                                        })
                                        break
                                    default:
                                        break
                                }

                                this.session.on('ended', () => {
                                    this.$emit('onevent', 'ended')
                                    this.status['description'] = 'ended'

                                    this.status['results'] = true
                                })

                                this.session.on('failed', (error) => {
                                    this.$emit('onevent', 'failed')
                                    this.status['description'] = 'failed'
                                    this.failed(error)
                                })

                                this.session.on('peerconnection', (event) =>
                                    event.peerconnection.ontrack = (event) => {
                                        if (event.streams && event.streams[0])
                                            if (this.$refs.peer)
                                                this.$refs.peer.srcObject = event.streams[0]
                                            else
                                                console.error('Remote audio ref not available')
                                        else
                                            console.error('No remote streams in ontrack event')
                                    }
                                )
                            })
                            this.ua.start()
                        } else
                            this.ua.register()
                    } else
                        this.status['description'] = 'nocredential'
                } else
                    this.status['description'] = 'nocredential'
            })
        },
        data() {
            return {
                session: this.session,
                username: this.endpoint['username'],
                direction: this.direction,
                status: this.status,
                extras: this.extras,
                information: this.information,
                did: this.models['destination'],
                theme: this.theme,
                duration: this.models['duration']
            }
        },
        xuid() {
            let xid = Date.now() / 1000
            if (!String(xid).includes('.'))
                xid = `${xid}.0`
            return xid
        },
        call() {
            try {
                if (this.models['destination'])
                    navigator.mediaDevices.getUserMedia(this.media)
                        .then((stream) => {
                            this.streams['audio'] = stream
                            if (this.$refs.context)
                                this.$refs.context.srcObject = stream

                            if (!this.ua || !stream) {
                                console.error('UA not initialized or local stream not available')
                                return
                            }

                            this.ua.call(this.models['destination'], {
                                mediaConstraints: this.media,
                                mediaStream: stream,
                                rtcOfferConstraints: {
                                    offerToReceiveAudio: true,
                                    offerToReceiveVideo: false,
                                },
                                extraHeaders: [
                                    `X-Unique-ID: ${uuidv4()}`
                                ]
                            })

                            this.status['description'] = 'dialing'

                            this.$emit('onevent', 'dialing')
                        })
            } catch (error) {
                console.error('Error accessing local media: ', error)
            }
        },
        answer() {
            try {
                navigator.mediaDevices.getUserMedia(this.media)
                    .then((stream) => {
                        this.streams['audio'] = stream
                        if (this.$refs.context)
                            this.$refs.context.srcObject = stream

                        if (!this.ua || !stream) {
                            console.error('UA not initialized or local stream not available')
                            return
                        }

                        if (this.session && this.status['description'] === 'incoming') {
                            this.session.answer({
                                mediaConstraints: this.media,
                                mediaStream: stream
                            })
                            this.tones.ringtone.pause()
                        }
                    })
            } catch (error) {
                console.error('Error accessing local media: ', error)
            }
        },
        reject() {
            if (this.session) {
                this.session.terminate({
                    status_code: 486,
                    reason_phrase: 'Busy Here'
                })
                this.cleanup()
            }
        },
        hangup() {
            if (this.session)
                this.session.terminate()
        },
        dialpad(key) {
            if (this.session)
                this.session.sendDTMF(key)
        },
        forward() {
            if (this.session) {
                this.session.refer(this.models['destination'])
                this.session.terminate({
                    status_code: 302,
                    reason_phrase: 'Call Forwarded',
                    extra_headers: [
                        `Contact: <${this.models['destination']}>`
                    ]
                })
                this.cleanup()
            }
        },
        failed(error) {
            if (error && error.message
                && error.message.status_code === 486) {
                this.tones.dtmfTone.pause()
                setTimeout(() => this.tones.busyTone.play(), 10)
                setTimeout(() => {
                    this.tones.busyTone.pause()
                    this.cleanup()
                }, 7500)
            } else
                this.cleanup()
        },
        mute() {
            if (this.session && this.session.isEstablished())
                this.session.connection.getSenders().forEach(sender => {
                    if (sender.track) {
                        sender.track.enabled = this.status['mute']
                        this.status['mute'] = !this.status['mute']
                    }
                })
        },
        hold() {
            if (this.session && this.session.isEstablished()) {
                if (this.status['hold']) {
                    this.status['mute'] = false
                    this.session.unhold({
                        success: () => { },
                        failure: (error) => console.error('Failed to resume call: ', error)
                    })
                }
                else
                    this.session.hold({
                        success: () => { },
                        failure: (error) => console.error('Failed to put call on hold: ', error)
                    })
                this.status['hold'] = !this.status['hold']
            }
        },
        cleanup() {
            this.session = null

            Object.keys(this.streams).forEach((key) => {
                if (this.streams[key])
                    this.streams[key].getTracks().forEach(track => track.stop())
            })

            Object.keys(this.tones).forEach((key) => this.tones[key].pause())

            if (this.$refs.context)
                this.$refs.context.srcObject = null
            if (this.$refs.peer)
                this.$refs.peer.srcObject = null

            this.models['destination'] = ''
            this.models['duration'] = null

            Object.keys(this.status).forEach((key) => {
                if (key !== 'registration' && key !== 'description')
                    this.status[key] = false
            })

            this.extras = {}

            this.information = {}

            this.status['description'] = this.status['registration']
                ? 'onhook'
                : 'offline'
        }
    }
}
</script>

<style scoped src="../../assets/css/components/phone/sip.css"></style>
<style scoped src="../../assets/css/components/phone/sip_dark.css"></style>